(function ($) {
  'use strict';

  /**
   * Toggle accordions
   */
  $('.course-structure .course-structure__item > .course-structure__toggle').click(function () {
    var $accordionToggle = $(this),
      $accordionText = $accordionToggle.siblings('.course-structure__content');

    if ($accordionToggle.hasClass('active')) {
      $accordionToggle.removeClass('active');
      slideUp($accordionText);
    } else {
      $accordionToggle.addClass('active');
      slideDown($accordionText);
    }

    return false;
  });

  /**
   * Update current accordion and enable target accordion
   */
  $('.course-structure .course-structure__options button').click(function (e) {
    var $currentTarget = $(e.currentTarget),
      $currentContent = $currentTarget.html(),
      $currentParent = $currentTarget.closest('.course-structure__item'),
      $target = $($currentTarget.data('target')),
      $targetParent = $target.closest('.course-structure__item'),
      $nextList = optionsChanged($currentParent);

    // If we're in the middle of changing options, then disable all options and reenable next
    if ($nextList.length > 0) {
      $nextList.each(function (index, $elem) {
        toggleNext($($($elem).find('.course-structure__options:not(.hidden)')), $($elem.closest('.course-structure__item')), false);
      });
      hideResults();
      updateCurrent($currentParent, $currentContent);
      toggleNext($target, $targetParent, true);
    } else {
      hideResults();
      updateCurrent($currentParent, $currentContent);
      toggleNext($target, $targetParent, true);
    }
  });

  /**
   * Updates info of accordion with content
   * @param {jQuery} $parent 
   * @param {jQuery} $content
   */
  function updateCurrent($parent, $content) {
    // Update current accordion
    setTitle($parent, $content, true);
    $parent.find('.course-structure__toggle').removeClass('active');
    slideUp($parent.find('.course-structure__content'));
  }

  /**
   * Toggles the state of the next accordion depending on the state value
   * @param {jQuery} $next 
   * @param {jQuery} $nextParent 
   * @param {boolean} state 
   */
  function toggleNext($next, $nextParent, state = true) {
    if (!state) {
      $nextParent.addClass('disabled');
      $nextParent.attr('disabled', true);
      $nextParent.find('.course-structure__toggle').addClass('active').removeAttr('disabled');
      $nextParent.find('.course-structure__content').slideUp(300, function () {
        $next.addClass('hidden');
      });
    } else {
      $next.removeClass('hidden');
      $nextParent.removeClass('disabled');
      $nextParent.find('.course-structure__toggle').addClass('active').removeAttr('disabled');
      slideDown($nextParent.find('.course-structure__content'));
    }
  }

  function optionsChanged($elem) {
    var state = [],
      $list = $($elem.find('~ .course-structure__item'));

    if ($list.length > 0 && !$list.hasClass('disabled')) {
      state = $list;
    }

    return state;
  }

  /**
   * 
   * @param {jQuery} $elem 
   * @param {jQuery} $content 
   * @param {boolean} state 
   */
  function setTitle($elem, $content, state = true) {
    if (!state) {
      $elem.find('.js-cs__title').removeClass('hidden');
      $elem.find('.js-cs__update').addClass('hidden');
    } else {
      $elem.find('.js-cs__title').addClass('hidden');
      $elem.find('.js-cs__update').removeClass('hidden').html($content);
    }
  }

  function slideUp($elem) {
    $elem.slideUp(300, function () {
      $(this).removeClass('active').removeAttr('style');
    });
  }

  function slideDown($elem) {
    $elem.slideDown(300, function () {
      $(this).addClass('active').removeAttr('style');
    });
  }

  function hideResults() {
    $('.course-structure .course-accordion__list').addClass('hidden');
  }
}(jQuery));